import React from "react";
// import AppIcons from "../../assets/images/icons";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";

// import Transparency from '../../assets/images/icons/Transparency.svg';
// import Bestvalue from '../../assets/images/icons/Bestvalue.svg';
// import Easyclosings from '../../assets/images/icons/Easyclosings.svg';
// import network from '../../assets/images/icons/network.svg';

import './OurValues.scss'
import AppIcons from "../../assets/images/icons";



function OurValues() {

  const valueContent = [
    {
      className: 'col-lg-3 col-md-6 col-sm-6 col-xs-12',
      title: 'INTEGRITY FIRST',
      icon: AppIcons.intIst,
    },
    {
      className: 'col-lg-3 col-md-6 col-sm-6 col-xs-12',
      title: 'GLOBAL MINDSET',
      icon: AppIcons.globalMind,
    },
    {
      className: 'col-lg-3 col-md-6 col-sm-6 col-xs-12',
      title: 'INNOVATION & TECHNOLOGY',
      icon: AppIcons.innovTech,
    },
    {
      className: 'col-lg-3 col-md-6 col-sm-6 col-xs-12',
      title: 'EXCELLENCE IN EVERY SERVICE',
      icon: AppIcons.Excelnce,
    },

  ];

  return (
    <>
      <div className="value-grid-wrp f-wrp">
        <div className="row">
          {valueContent.map((element, key) => (
            <div className={`${element.className} each-blk-sec`} key={key}>
              <div className="each-abt-blk f-wrp">
                <div className='icon-blk'>
                  {element.icon && <span><img src={element.icon} alt="our-value icon" /></span>}
                </div>
                <div className='cont-blk'>
                  <h3>{element.title}</h3>
                 {element.discription && <p>{element.discription}</p>}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default OurValues;